import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onClick", "buttonLabel"];
import React from 'react';
import { useFlag } from '@carnica/utils/hooks';
import { cnBem } from "../../../../shared/lib";
import { IconRefresh } from "../../../message/lib/hooks/useMessageMenu/utils";
import styles from "./styles.pcss";
var cnRefreshButton = cnBem('refresh-button', styles);
export var RefreshButton = function RefreshButton(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    buttonLabel = _ref.buttonLabel,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isHovered = _useFlag2[0],
    setIsHovered = _useFlag2[1];
  return /*#__PURE__*/React.createElement(IconRefresh, _extends({}, otherProps, {
    "aria-label": buttonLabel,
    className: cnRefreshButton(null, [className]),
    color: isHovered ? 'secondary-invert' : 'primary-invert',
    onClick: onClick,
    onMouseEnter: setIsHovered.on,
    onMouseLeave: setIsHovered.off,
    tagName: "button",
    type: "button"
  }));
};